export default "dist/images/e97de4daa946331c7e99dee9c05d629c.png";